import { createRouter, createWebHistory } from "vue-router";

import AccueilViras from "@/pages/AccueilViras.vue";

// Les autres pages sont chargées à la demande : le site s'ouvre plus vite.
const routes = [
  { path: "/", component: AccueilViras, meta: { title: "Accueil" } },

  { path: "/groupe", component: () => import("@/views/LeGroupeView.vue"), meta: { title: "Le Groupe" } },

  // Filiales
  { path: "/filiales/louga-voyages", component: () => import("@/views/filiales/LougaVoyages.vue"), meta: { title: "Louga Voyages" } },
  { path: "/filiales/clinique-demassi", component: () => import("@/views/filiales/CliniqueDemassi.vue"), meta: { title: "Clinique DemAssi" } },
  { path: "/filiales/lamien-consulting", component: () => import("@/views/filiales/LamienConsulting.vue"), meta: { title: "Lamien Consulting" } },
  { path: "/filiales/saveur-deco", component: () => import("@/views/filiales/SaveurDeco.vue"), meta: { title: "Saveurs N'Deco" } },
  { path: "/filiales/baraka-boutique", component: () => import("@/views/filiales/BoutiqueBaraka.vue"), meta: { title: "Boutique Baraka" } },
  { path: "/filiales/pool-formation", component: () => import("@/views/filiales/PoolFormaion.vue"), meta: { title: "Pool Formation" } },
  { path: "/filiales/centre-almanassik", component: () => import("@/views/filiales/CentreAlmanassik.vue"), meta: { title: "Centre Al-manassik" } },
  { path: "/filiales/maison-viras", component: () => import("@/views/filiales/MaisonViras.vue"), meta: { title: "Maison VIRAS" } },
  { path: "/filiales/viras-technologies", component: () => import("@/views/filiales/VirasTechnologie.vue"), meta: { title: "VIRAS Technologies" } },
  // Toute nouvelle filiale créée dans l'admin a automatiquement sa page
  { path: "/filiales/:slug", component: () => import("@/views/filiales/FilialeGenerique.vue") },

  // Services
  { path: "/services", component: () => import("@/views/ServiceView.vue"), meta: { title: "Nos services" } },
  { path: "/services/voyages", component: () => import("@/views/services/OrganisationVente.vue"), meta: { title: "Voyages" } },
  { path: "/services/visa-assurances", component: () => import("@/views/services/VisaAssurance.vue"), meta: { title: "Visa & assurances" } },
  { path: "/services/transport", component: () => import("@/views/services/TransportView.vue"), meta: { title: "Transport" } },
  { path: "/services/transfert-argent", component: () => import("@/views/services/TransfertArgent.vue"), meta: { title: "Transfert d'argent" } },
  { path: "/services/evenements", component: () => import("@/views/services/OrganisationEvenement.vue"), meta: { title: "Événements" } },
  { path: "/services/marketing", component: () => import("@/views/services/MarketingView.vue"), meta: { title: "Marketing" } },

  // Actualités (contenu géré depuis l'admin)
  { path: "/actualites", component: () => import("@/pages/ActualiteView.vue"), meta: { title: "Actualités" } },
  { path: "/actualites/:slug", component: () => import("@/pages/ActualiteDetail.vue") },

  { path: "/contact", component: () => import("@/views/filiales/ContactView.vue"), meta: { title: "Contact" } },

  // Ancienne adresse de l'admin : l'administration est désormais sur le backend
  { path: "/admin", redirect: "/" },

  // Page inconnue → accueil
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si bouton retour navigateur
    if (savedPosition) {
      return savedPosition;
    }
    // Lien vers une ancre (#form, #location…)
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 100 };
    }
    // Filtres de la page Actualités : on ne remonte pas
    if (to.path === from.path) {
      return false;
    }
    // Sinon toujours en haut
    return { top: 0 };
  },
});

// Titre de l'onglet du navigateur
router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title === "Accueil" ? "Groupe VIRAS — African Excellence & Innovation" : `${to.meta.title} — Groupe VIRAS`;
  }
});

export default router;
